<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-body">
    <ng-container *ngIf="dialog$ | async as dialog">
      <div class="text-justify mb-2">If selected allows donors to select being anonymous when they join the event. If the donor selects this option, other participants will not see the donor's name when shown in the activity list. Only applicable for donations, not for live auction or last hero game.</div>
    </ng-container>
  </div>
</ng-container>
